export enum ScanPrefix {
    SafetyPointId = 'SafetyPointId'
}
